import { render } from "./HomeSearcher.vue?vue&type=template&id=354ebaea"
import script from "./HomeSearcher.vue?vue&type=script&lang=js"
export * from "./HomeSearcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__